import {init, captureException, captureMessage, browserTracingIntegration, replayIntegration, feedbackIntegration, setUser, getFeedback } from '@sentry/vue'

const {VITE_SENTRY_ENABLED, VITE_ENV} = import.meta.env

export const SENTRY_ENABLED = VITE_SENTRY_ENABLED?.toLowerCase() == 'true'

export const sentryInit = (app, router) => {
  if (SENTRY_ENABLED) {
    init({
      app,
      environment: import.meta.env.VITE_ENV,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      tunnel: '/api/sentry',
      ignoreErrors: [
        'Failed to fetch dynamically imported module', 'FST_JWT_AUTHORIZATION_TOKEN_EXPIRED',
        'Email not found', 'Invalid Password', 'Your One-Time Passcode is invalid',
        "Failed to execute 'readText' on 'Clipboard': Read permission denied", 'No Zendesk ticket selected'
      ],
      integrations: [
        browserTracingIntegration({ router }),
        ...(VITE_ENV == 'production'
          ? [replayIntegration({ networkDetailAllowUrls: [window.location.origin] })]
          : []),
        feedbackIntegration({
          autoInject: false,
          showName: false,
          showEmail: false,
          colorScheme: 'system',
        })
      ],
      tracesSampleRate: import.meta.env.VITE_SENTRY_SAMPLE_RATE || 0.1,
      tracePropagationTargets: [
        /^https:\/\/cash\.ustechsupport\.com/,
        /^https:\/\/cash-stage\.ustechsupport\.com/,
        /^https:\/\/cash-demo\.ustechsupport\.com/,
        /^https:\/\/cash\.techinnovators\.dev/,
        /^http:\/\/localhost:\d+/,
        /^\/api\//,
      ],
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: VITE_ENV == 'production' ? 0.25 : 0
    })
  }
}

export const getSentryFeedback = () => SENTRY_ENABLED ? getFeedback() : null

export const sentryException = data => SENTRY_ENABLED ? captureException(data) : null
export const sentryMessage = data => SENTRY_ENABLED ? captureMessage(data) : null
export const sentryUser = data => SENTRY_ENABLED ? setUser(data) : null